import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { ISelfListingTitleProps } from 'types/interfaces';

export const SelfListingTitle: FC<ISelfListingTitleProps> = ({ title }: ISelfListingTitleProps): ReactElement => {
    return <h3 className={styles.title}>{title}</h3>;
};
